import { __assign } from "tslib";
import { createTheme as createMuiTheme } from '@material-ui/core/styles';
import { default as breakpoints } from './breakpoints';
import { palette, paletteDark } from './palette';
import { shape } from './shape';
import { default as typography } from './typography';
import { getOverrides } from './overrides';
export function createTheme(options) {
    var type = options && options.palette && options.palette.type;
    var direction = options && options.direction;
    var zIndex = options === null || options === void 0 ? void 0 : options.zIndex;
    var partialTheme = createMuiTheme({
        breakpoints: breakpoints,
        typography: typography,
        shape: shape,
        direction: direction === 'rtl' ? 'rtl' : 'ltr',
        palette: type === 'dark' ? paletteDark : palette,
        props: {
            MuiButtonBase: {
                disableRipple: true,
            },
        },
        zIndex: zIndex,
    });
    return createMuiTheme(__assign(__assign({}, partialTheme), { overrides: getOverrides(partialTheme) }));
}
export var bbTheme = createTheme();
export var bbThemeDark = createTheme({ palette: { type: 'dark' } });
export default bbTheme;
//# sourceMappingURL=theme.js.map